/**
 * Unsplash CDN URL builder — forces WebP delivery + provides responsive srcset.
 * Usage:
 *   const { src, srcSet } = uns("photo-1503376780353-7e6692767b70", { w: 1400 });
 *   <img src={src} srcSet={srcSet} sizes="(min-width:900px) 1200px, 100vw" />
 */
export function uns(id, { w = 1200, q = 72, widths = [480, 800, 1200, 1600] } = {}) {
  const base = `https://images.unsplash.com/${id}`;
  const p = (width) =>
    `${base}?auto=format&fm=webp&fit=crop&q=${q}&w=${width}`;
  return {
    src: p(w),
    srcSet: widths.map((width) => `${p(width)} ${width}w`).join(", "),
  };
}
